import React from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import Tooltip from 'components/tooltip'
import Link from 'components/link'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import styles from './styles.scss'
import CreditNeededInfoContent from './CreditNeededInfoContent'
import ImageAndMobCTA from './imageAndMobCta'
import TileCollapseSection from './tileCollapseSection'
import DesktopCtaSection from './desktopCtaSection'

const CardTile = ({
  slug,
  name,
  image,
  annualFeeFormatted,
  category,
  issuerPublicName,
  introBalanceTransferPeriodFormatted,
  introPurchaseAprPeriodFormatted,
  ratesAndFeesUrl,
  balanceTransferFeeFormatted,
  introBonus,
  rewardsUnit,
  introBonusPoints,
  featuredCategory,
  creditNeeded,
  securityDepositMinimum,
  aprRangeFormatted,
  marketingBullets,
  isDetailsOpen,
  onToggleDetails,
  trackSnowplowEvent,
  ctaUrl,
  uuid,
}) => {
  const introPurchaseAprPeriodFormattedUpdate = introPurchaseAprPeriodFormatted.replace('for ', ''),
    aprRangeFormattedUpdate = aprRangeFormatted.replace('%%', '%')
  let introBonusString = ''
  switch (rewardsUnit) {
    case 'dollars': introBonusString = introBonus ? `$${introBonus.toLocaleString()}` : null
      break
    case 'points': introBonusString = introBonusPoints ? `${introBonusPoints.toLocaleString()} points` : null
      break
    case 'miles': introBonusString = introBonusPoints ? `${introBonusPoints.toLocaleString()} miles` : null
      break
    default:
  }
  const securityDepositMinText = securityDepositMinimum ? `$${securityDepositMinimum.toLocaleString()}` : 'N/A'
  const dimensionsValFunc = (cat) => {
      switch (cat) {
        case 'rewards':
          return [annualFeeFormatted, introBonusString]
        case 'balance-transfer':
          return [introBalanceTransferPeriodFormatted, balanceTransferFeeFormatted]
        case 'zero-percent':
          return [annualFeeFormatted, introPurchaseAprPeriodFormattedUpdate]
        case 'secured':
          return [annualFeeFormatted, securityDepositMinText]
        case 'student':
          return [annualFeeFormatted, aprRangeFormattedUpdate]
        case 'low-interest':
          return [annualFeeFormatted, introPurchaseAprPeriodFormattedUpdate]
        default:
          return ''
      }
    },
    dimensionsVal = (cat) => dimensionsValFunc(cat === 'featured' ? featuredCategory.slug : cat),
    dimensionsPerCategoryTitleFunc = (cat) => {
      switch (cat) {
        case 'rewards':
          return ['Annual Fee', 'Welcome Offer']
        case 'balance-transfer':
          return ['0% Balance Transfer Period', 'Balance Transfer Fee']
        case 'zero-percent':
          return ['Annual Fee', '0% Purchase Period']
        case 'secured':
          return ['Annual Fee', 'Security Deposit Min.']
        case 'student':
          return ['Annual Fee', 'Ongoing Variable APR']
        case 'low-interest':
          return ['Annual Fee', '0% Purchase Period']
        default:
          return ''
      }
    },
    dimensionsPerCategoryTitle = (cat) => dimensionsPerCategoryTitleFunc(cat === 'featured' ? featuredCategory.slug : cat),
    toStringCredit = (val) => {
      switch (val) {
        case 'excellent-credit':
          return 'Excellent'
        case 'good-credit':
          return 'Good'
        case 'fair-credit':
          return 'Fair'
        case 'poor-credit':
          return 'Poor'
        default:
      }
    },
    creditNeededText = (creditNeeded.includes('new-credit')) ? 'None' : `${creditNeeded.map(toStringCredit).join(', ')} `

  return (
    <div className={styles.cardsTable}>
      <div className={styles.cardHeader}>
        <div className={styles.imageTxtDimensions}>
          <div className={`mb-4 ${styles.imageTxtBullets}`}>
            <ImageAndMobCTA image={image} name={name} ctaUrl={ctaUrl} uuid={uuid} issuerPublicName={issuerPublicName} ratesAndFeesUrl={ratesAndFeesUrl} category={category} />
            <div className={styles.txtAndBullets}>
              <Font type="body" weight="bold" color="neutral">
                {name}
              </Font>
              <div className={styles.mobDimensions}>
                <ul className={styles.list}>
                  <li>
                    <Font type="bodySmall" weight="semiBold" className="mt-8" nowrap>
                      {dimensionsVal(category)[0] || 'N/A'} {' '}
                    </Font>
                    <Font type="disclaimer" color="lighter">
                      {dimensionsPerCategoryTitle(category)[0]}
                    </Font>
                  </li>
                  <li>
                    <Font type="bodySmall" weight="semiBold" className="mt-8">
                      {dimensionsVal(category)[1] || 'N/A'}{' '}
                    </Font>
                    <Font type="disclaimer" color="lighter">
                      {dimensionsPerCategoryTitle(category)[1]}
                    </Font>
                  </li>
                  <li>
                    <Font type="bodySmall" weight="semiBold" className="mt-8">
                      {creditNeededText}
                    </Font>{' '}
                    <Font type="disclaimer" color="lighter">
                      Credit Needed
                    </Font>
                    <Link rel="nofollow">
                      <Tooltip
                        triggerContent={(
                          <i className={`cred-icon icon-help-outline ${styles.icon}`} />
                        )}
                        placement="top"
                        className={styles.tooltip}
                        gaCategory={category}
                        gaAction="Info"
                        analyticsOptions={{ contentSubject: 'Credit Needed Tooltip' }}
                      >
                        <CreditNeededInfoContent />
                      </Tooltip>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.desktopCardDimensions}>
            <div className={styles.dim}>
              <Font type="disclaimer" color="lighter">
                {dimensionsPerCategoryTitle(category)[0]}
              </Font>
              <Font type="bodySmall" weight="semiBold">
                {dimensionsVal(category)[0] || 'N/A'}
              </Font>
            </div>
            <div className={styles.dim}>
              <Font type="disclaimer" color="lighter">
                {dimensionsPerCategoryTitle(category)[1]}
              </Font>

              <Font type="bodySmall" weight="semiBold">
                {dimensionsVal(category)[1] || 'N/A'}
              </Font>
            </div>
            <div className={styles.dim}>

              <Font type="disclaimer" color="lighter">
                  Credit Needed
              </Font>

              <Font type="bodySmall" weight="semiBold">
                {creditNeededText}
                <Link rel="nofollow">
                  <Tooltip
                    triggerContent={
                      <i className={`cred-icon icon-help-outline ${styles.icon}`} />
                    }
                    placement="left"
                    className={styles.tooltip}
                    gaCategory={category}
                    gaAction="Info"
                    analyticsOptions={{ contentSubject: 'Credit Needed Tooltip' }}
                  >
                    <CreditNeededInfoContent />
                  </Tooltip>
                </Link>
              </Font>
            </div>
          </div>
        </div>
        <DesktopCtaSection name={name} uuid={uuid} ratesAndFeesUrl={ratesAndFeesUrl} ctaUrl={ctaUrl} category={category} issuerPublicName={issuerPublicName} />
      </div>
      <TileCollapseSection marketingBullets={marketingBullets} trackSnowplowEvent={trackSnowplowEvent} onToggleDetails={onToggleDetails} isDetailsOpen={isDetailsOpen} slug={slug} />
    </div>
  )
}

CardTile.propTypes = {
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  ratesAndFeesUrl: PropTypes.string,
  annualFeeFormatted: PropTypes.string.isRequired,
  introBalanceTransferPeriodFormatted: PropTypes.string.isRequired,
  introPurchaseAprPeriodFormatted: PropTypes.string.isRequired,
  balanceTransferFeeFormatted: PropTypes.string.isRequired,
  introBonus: PropTypes.number,
  creditNeeded: PropTypes.array.isRequired,
  featuredCategory: PropTypes.array.isRequired,
  issuerPublicName: PropTypes.string.isRequired,
  rewardsUnit: PropTypes.string.isRequired,
  introBonusPoints: PropTypes.string.isRequired,
  securityDepositMinimum: PropTypes.string,
  aprRangeFormatted: PropTypes.string.isRequired,
  marketingBullets: PropTypes.array.isRequired,
  onToggleDetails: PropTypes.func.isRequired,
  isDetailsOpen: PropTypes.bool,
  trackSnowplowEvent: PropTypes.func.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
}

CardTile.defaultProps = {
  isDetailsOpen: false,
}

export { CardTile }

export default withSnowplowContexts(CardTile)
